const eventsService = {
  simulateClick: (elem: HTMLElement): void => {
    const evt = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    })
    elem.dispatchEvent(evt)
  },
  dispatchCustomEvent: (name: string, data: {}): void => {
    const evt = document.createEvent('CustomEvent')
    evt.initCustomEvent(name, false, false, data)
    window.dispatchEvent(evt)
  },
}

export default eventsService
